export default {
    home: {
        title: "首页",
        key: "home",
        name: "home"
    },
    patientAdd: {
        title: "新增患者",
        key: "patientAdd",
        name: "patientAdd"
    },
    schemeList: {
        title: "方案库",
        key: "schemeList",
        name: "schemeList"
    },
    schemeAdd: {
        title: "新增治疗方案",
        key: "schemeAdd",
        name: "schemeAdd"
    },
    filterAnalysis: {
        title: "筛查评估分析",
        key: "filterAnalysis",
        name: "filterAnalysis"
    },
    teamDoctorList: {
        title: "成员管理",
        key: "teamDoctorList",
        name: "teamDoctorList"
    },

    addQues: {
        title: "查看问卷",
        key: "addQues",
        name: "addQues"
    },
    patientLists: {
        title: "筛查人员库",
        key: "patientLists",
        name: "patientLists"
    },
    teamList: {
        title: "团队管理",
        key: "teamList",
        name: "teamList"
    },
    organizationList: {
        title: "机构管理",
        key: "organizationList",
        name: "organizationList"
    },
    deptList: {
        title: "科室管理",
        key: "deptList",
        name: "deptList",
    },
    diseaseList: {
        title: "病种管理",
        key: "diseaseList",
        name: "diseaseList"
    },
    drugList: {
        title: "药品库",
        key: "drugList",
        name: "drugList"
    },
    userList: {
        title: "用户管理",
        key: "userList",
        name: "userList"
    },
    roleList: {
        title: "角色管理",
        key: "roleList",
        name: "roleList"
    },
    patientConfig: {
        title: "指标配置",
        key: "patientConfig",
        name: "patientConfig"
    },
    patientSummary: {
        title: "摘要配置",
        key: "patientSummary",
        name: "patientSummary"
    },
    patientSelf: {
        title: "患者摘要配置",
        key: "patientSelf",
        name: "patientSelf"
    },
    userBasic: {
        title: "患者基本信息",
        key: "userBasic",
        name: "userBasic"
    },
    filterBasic: {
        title: "筛查人员信息",
        key: "filterBasic",
        name: "filterBasic",
    },
    medicalBasic: {
        title: "确诊人员信息",
        key: "medicalBasic",
        name: "medicalBasic",
    },

    typeFollowUp: {
        title: "随访类型管理",
        key: "typeFollowUp",
        name: "typeFollowUp"
    },
    createNewObject: {
        title: "创建随访对象",
        key: "createNewObject",
        name: "createNewObject"
    },
    objectList: {
        title: "随访对象",
        key: "objectList",
        name: "objectList"
    },
    creatTask: {
        title: "创建随访任务",
        key: "creatTask",
        name: "creatTask"
    },


    typeFollowUp: {
        title: "随访类型管理",
        key: "typeFollowUp",
        name: "typeFollowUp"
    },
    createNewObject: {
        title: "创建随访对象",
        key: "createNewObject",
        name: "createNewObject"
    },
    objectList: {
        title: "随访对象",
        key: "objectList",
        name: "objectList"
    },
    creatTask: {
        title: "创建随访任务",
        key: "creatTask",
        name: "creatTask"
    },
    newsList: {
        title: "宣教库",
        key: "newsList",
        name: "newsList"
    },
    newsAdd: {
        title: "发布文章",
        key: "newsAdd",
        name: "newsAdd"
    },
    createFollow: {
        title: "创建随访任务",
        key: "createFollow",
        name: "createFollow"
    },
    patientAnalysis: {
        title: "评估分析",
        key: "patientAnalysis",
        name: "patientAnalysis"
    },

    patientConfirmed: {
        title: "确诊患者分组",
        key: "patientConfirmed",
        name: "patientConfirmed"
    },
    patientGroup: {
        title: "筛查人员分组",
        key: "patientGroup",
        name: "patientGroup"
    },
    analysis: {
        title: "筛查评估分析",
        key: "analysis",
        name: "analysis"
    },
    patientLabel: {
        title: "筛查人员标签",
        key: "patientLabel",
        name: "patientLabel"
    },
    confirmedLabel: {
        title: "确诊患者标签",
        key: "confirmedLabel",
        name: "confirmedLabel"
    },
    addGroup: {
        title: "新增分组",
        key: "addGroup",
        name: "addGroup"
    },
    confirmedGroup: {
        title: "确诊患者分组",
        key: "confirmedGroup",
        name: "confirmedGroup"
    },
    quesList: {
        title: "问卷库",
        key: "quesList",
        name: "quesList"
    },
    screenPatient: {
        title: "新增筛查人员",
        key: "screenPatient",
        name: "screenPatient"
    },
    confirmedLists: {
        title: "患者人员库",
        key: "confirmedLists",
        name: "confirmedLists"
    },
    confirmedAnalysis: {
        title: "评估分析",
        key: "confirmedAnalysis",
        name: "confirmedAnalysis"
    },

    typeManagement: {
        title: "随访任务列表",
        key: "typeManagement",
        name: "typeManagement"
    },
    editTask: {
        title: "编辑随访任务",
        key: "editTask",
        name: "editTask"
    },
    slowPatient: {
        title: "新增慢病患者",
        key: "slowPatient",
        name: "slowPatient"
    },
    addGroup2: {
        title: "新增分组",
        key: "addGroup2",
        name: "addGroup2"
    },
    surveyIndex: {
        title: "坐席执行",
        key: "surveyIndex",
        name: "surveyIndex"
    },
    patientApply: {
        title: "签约管理",
        key: "patientApply",
        name: "patientApply"
    },
    templateQuestionnaire: {
        title: "问卷模版库",
        key: "templateQuestionnaire",
        name: "templateQuestionnaire"
    },
    module_news: {
        title: "首页文章",
        key: "module_news",
        name: "module_news"
    },
    homeNewsAdd: {
        title: "发布文章",
        key: "homeNewsAdd",
        name: "homeNewsAdd"
    },
    diseaseBaseList: {
        title: "基础病种管理",
        key: "diseaseBaseList",
        name: "diseaseBaseList"
    },
    depts: {
        title: "科室信息",
        key: "depts",
        name: "depts"
    },
    information: {
        title: "医院信息",
        key: "information",
        name: "information"
    },
    miniQuestionnaire: {
        title: "测评问卷库",
        key: "miniQuestionnaire",
        name: "miniQuestionnaire"
    },
    deptCodeList: {
        title: "科室二维码",
        key: "deptCodeList",
        name: "deptCodeList"
    },
    addressList: {
        title: "通讯录",
        key: "addressList",
        name: "addressList"
    },
    addressList1: {
      title: "通讯录",
      key: "addressList1",
      name: "addressList1"
    },
    // 服务包工单
    packageOrder: {
        title: "服务包工单",
        key: "packageOrder",
        name: "packageOrder"
    },
    // 服务包详情
    packageDetail: {
        title: "服务包详情",
        key: "packageDetail",
        name: "packageDetail"
    },
    // 服务包问卷 
    packageQues: {
        title: "服务包问卷",
        key: "packageQues",
        name: "packageQues"
    },
    diagnosis: {
        title: "诊断库",
        key: "diagnosis",
        name: "diagnosis",
    },
    diagnosisSort: {
        title: "诊断库排序",
        key: "diagnosisSort",
        name: "diagnosisSort",
    },
}
